import {
  DCS_CONSUMER_APPLICATION_INCHARGE,
  DCS_CONSUMER_APPLICATION_OPERATOR,
  DCS_CONSUMER_BILLING_INCHARGE,
  DCS_CONSUMER_BILLING_OPERATOR,
  POWER_CONSUMER_APPLICATION_INCHARGE,
  POWER_CONSUMER_APPLICATION_OPERATOR,
  POWER_CONSUMER_BILLING_INCHARGE,
  POWER_CONSUMER_BILLING_OPERATOR,
  dcsAdmin1Roles,
  dcsAdmin2Roles,
  otherUtilitiesAdmin1Roles,
  otherUtilitiesAdmin2Roles,
  otherUtilitiesApplicationAdmin3Roles,
  otherUtilitiesApplicationAdmin4Roles,
  otherUtilitiesBillingAdmin3Roles,
  otherUtilitiesBillingAdmin4Roles,
  powerAdmin1Roles,
  powerAdmin2Roles,
} from "common/constant";
import { getOptionValue } from "common/enums";

export const getUtilityWiseRoles = (utilityId, isApplication = true) => {
  const roles = {
    [getOptionValue("utilityOptions", "Power")]: {
      admin1Roles: powerAdmin1Roles,
      admin2Roles: powerAdmin2Roles,
      admin3Roles: isApplication
        ? [POWER_CONSUMER_APPLICATION_INCHARGE]
        : [POWER_CONSUMER_BILLING_INCHARGE],
      admin4Roles: isApplication
        ? [POWER_CONSUMER_APPLICATION_OPERATOR]
        : [POWER_CONSUMER_BILLING_OPERATOR],
    },
    [getOptionValue("utilityOptions", "DCS")]: {
      admin1Roles: dcsAdmin1Roles,
      admin2Roles: dcsAdmin2Roles,
      admin3Roles: isApplication
        ? [DCS_CONSUMER_APPLICATION_INCHARGE]
        : [DCS_CONSUMER_BILLING_INCHARGE],
      admin4Roles: isApplication
        ? [DCS_CONSUMER_APPLICATION_OPERATOR]
        : [DCS_CONSUMER_BILLING_OPERATOR],
    },
    [getOptionValue("utilityOptions", "Water")]: {
      admin1Roles: otherUtilitiesAdmin1Roles,
      admin2Roles: otherUtilitiesAdmin2Roles,
      admin3Roles: isApplication
        ? otherUtilitiesApplicationAdmin3Roles
        : otherUtilitiesBillingAdmin3Roles,
      admin4Roles: isApplication
        ? otherUtilitiesApplicationAdmin4Roles
        : otherUtilitiesBillingAdmin4Roles,
    },
    [getOptionValue("utilityOptions", "Sewage")]: {
      admin1Roles: otherUtilitiesAdmin1Roles,
      admin2Roles: otherUtilitiesAdmin2Roles,
      admin3Roles: isApplication
        ? otherUtilitiesApplicationAdmin3Roles
        : otherUtilitiesBillingAdmin3Roles,
      admin4Roles: isApplication
        ? otherUtilitiesApplicationAdmin4Roles
        : otherUtilitiesBillingAdmin4Roles,
    },
    [getOptionValue("utilityOptions", "Solid Waste")]: {
      admin1Roles: otherUtilitiesAdmin1Roles,
      admin2Roles: otherUtilitiesAdmin2Roles,
      admin3Roles: isApplication
        ? otherUtilitiesApplicationAdmin3Roles
        : otherUtilitiesBillingAdmin3Roles,
      admin4Roles: isApplication
        ? otherUtilitiesApplicationAdmin4Roles
        : otherUtilitiesBillingAdmin4Roles,
    },
  };

  return roles[utilityId] ?? [];
};
